import React from 'react'
import { Link,  } from 'react-router-dom';
import {english} from '../component/English';
let lang_name = localStorage.getItem('lang_name');
  if (lang_name ==null) {
    localStorage.setItem('lang',JSON.stringify(english));

    localStorage.setItem('lang_name','english');
  }
  const lang =JSON.parse(localStorage.getItem("lang"));
const Footer = () => {
    return (
        <div className="bottom_bar">
    <ul>
      <li id="home_icon">
        <Link to="/">
         <svg aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M16 8.414l-4.5-4.5L4.414 11H6v8h3v-6h5v6h3v-8h1.586L17 9.414V6h-1v2.414zM2 12l9.5-9.5L15 6V5h3v4l3 3h-3v7.998h-5v-6h-3v6H5V12H2z" fill="#fff"/></svg>
        <b>{lang.home}</b>
        </Link>
      </li>
      <li>
       <Link to="/booking">

          <svg viewBox="0 0 24 24"><path d="M11.5 7a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5zm0 1a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3zm-4.7 4.357l4.7 7.73l4.7-7.73a5.5 5.5 0 1 0-9.4 0zm10.254.52L11.5 22.012l-5.554-9.135a6.5 6.5 0 1 1 11.11 0h-.002z" fill="#fff"/></svg>
        <b>{lang.booking}</b>
       </Link>
      </li>
      <li>
        <Link to="/orders">
           <svg viewBox="0 0 24 24"><path d="M7 2h1a1 1 0 0 1 1 1v1h5V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3V3a1 1 0 0 1 1-1zm8 2h1V3h-1v1zM8 4V3H7v1h1zM6 5a2 2 0 0 0-2 2v1h15V7a2 2 0 0 0-2-2H6zM4 18a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V9H4v9zm8-5h5v5h-5v-5zm1 1v3h3v-3h-3z" fill="#fff"/></svg>
        <b>{lang.order_list}</b>
        </Link>
      </li>
    </ul>
    </div>
    )
}

export default Footer;
